export { default } from './DialogTitle';